import { useEffect, useState } from "react"
import clienteAxios from "../../../configAxios/configAxios";
import { checkIsNotEmpty, validarNumero, validarPassword, validarRut, validateEmail } from "../../../helper/validations";


export const useValidaciones = (value, initialValue) => {
    const [validaciones, setValidaciones] = useState(undefined);

    const validarCampo = (valor) => {
        if (!valor.name) return;
        if (valor.name.toLowerCase() === "rut" || valor.name.toLowerCase() === "rutfacturacion" || valor.name.toLowerCase() === "rutempresa") {
            if (!validarRut(valor.value)) {
                setValidaciones({ ...validaciones, [valor.name]: "error-formulario" });
            }
            else setValidaciones({ ...validaciones, [valor.name]: "formulario-success" });
        }
        else if (value.name.toLowerCase() === "telefono" || value.name.toLowerCase() === "telefonoempresa" || value.name.toLowerCase() === "telefonofacturacion") {
            if (!validarNumero(valor.value)) {
                setValidaciones({ ...validaciones, [value.name]: "error-formulario" })
            }
            else setValidaciones({ ...validaciones, [value.name]: "formulario-success" })
        }
        else if (value.name.toLowerCase() === "email" || value.name.toLowerCase() === "emailempresa" || value.name.toLowerCase() === "emailfacturacion") {
            if (!validateEmail(valor.value)) {
                setValidaciones({ ...validaciones, [value.name]: "error-formulario" })
            }
            else setValidaciones({ ...validaciones, [value.name]: "formulario-success" })
        }
        else if (value.name.toLowerCase() === "password" || value.name.toLowerCase() === "newpassword") {
            if (!validarPassword(valor.value)) {
                setValidaciones({ ...validaciones, [value.name]: "error-formulario" })
            }
            else setValidaciones({ ...validaciones, [value.name]: "formulario-success" })
        }
        else {
            if (!checkIsNotEmpty(valor.value)) {
                setValidaciones({ ...validaciones, [valor.name]: "error-formulario" });
            }
            else setValidaciones({ ...validaciones, [valor.name]: "formulario-success" });
        }
    }

    useEffect(() => {
        setValidaciones(initialValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (value !== undefined) validarCampo(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return [validaciones ? validaciones : initialValue, setValidaciones];
}

export const useRubros = () => {
    const [rubros, setRubros] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchRubros = async () => {
            try {
                let response = await clienteAxios.get('Parametro/activo/RUBRO');
                if (response.status === 200) {
                    let data = response.data.data;
                    setLoading(false);
                    setRubros(data);
                    return
                }
                setLoading(false)
                setError(true)
            } catch (error) {
                setLoading(false)
                setError(true)
            }
        };
        fetchRubros();
    }, [])
    return { rubros, loading, error }
}

export const useParametrosActivos = (modulo) => {
    const [parametros, setParametros] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchParametros = async () => {
            try {
                let response = await clienteAxios.get(`Parametro/activo/${modulo}`);
                if (response.status === 200) {
                    let data = response.data.data;
                    setLoading(false);
                    setParametros(data);
                    return
                }
                setLoading(false)
                setError(true)
            } catch (error) {
                setLoading(false)
                setError(true)
            }
        };
        fetchParametros();
    }, [])
    return { parametros, loading, error }
}

export const useRegiones = () => {
    const [regiones, setRegiones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchRegiones = async () => {
            try {
                let response = await clienteAxios.get('ListarUbigeoPorRegion');
                if (response.status === 200) {
                    let data = response.data.data;
                    setLoading(false);
                    setRegiones(data);
                    return
                }
                setLoading(false)
                setError(true)
            } catch (error) {
                setLoading(false)
                setError(true)
            }
        };
        fetchRegiones();
    }, [])
    return { regiones, loading, error }
}

export const useComunas = (idRegion) => {
    const [comunas, setComunas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchComunas = async () => {
            try {
                let response = await clienteAxios.get(`buscarubigeoporidregion/${idRegion}`)
                if (response.status === 200) {
                    let data = response.data.data;

                    setLoading(false);
                    setComunas(data);
                    return
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        if (idRegion) fetchComunas();
    }, [idRegion])
    return { comunas, loading, error }
}

export const useConcesionariosRegion = (idRegion, servicio) => {
    const [concesionarios, setConcesionarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchConcesionarios = async () => {
            try {
                let response = await clienteAxios.get(`oficina/region/${idRegion}/${servicio}`)
                if (response.status === 200) {
                    let data = response.data.data;

                    setLoading(false);
                    setConcesionarios(data);
                    return
                }
                setLoading(false);
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        if (idRegion && servicio) fetchConcesionarios();
    }, [idRegion, servicio])
    return { concesionarios, loading, error }
}

export const useOficinaConcesionario = (idOficina) => {
    const [datos, setDatos] = useState(undefined);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDatosOficina = async () => {
            try {
                let response = await clienteAxios.get(`Oficina/id/${idOficina}`);
                if (response.status === 200) {
                    let data = response.data.data;

                    if (data && data.Servicios && data.Servicios.length > 0) {
                        let oficina = data.Servicios.filter((servicio) => servicio.Servicio === "Venta")
                        if (oficina.length > 0) oficina[0].Direccion = data.Direccion;
                        setLoading(false);
                        setDatos(oficina.length > 0 ? oficina[0] : undefined);
                        return;
                    }
                }
                setError(true);
                setLoading(false);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
        if (idOficina) fetchDatosOficina();
    }, [idOficina])

    return { datos, error, loading }

}

export const useAllConcesionarios = () => {
    const [concesionarios, setConcesionarios] = useState(undefined);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConcesionarios = async () => {
            try {
                let response = await clienteAxios.get('Concesionarios/A');
                if (response.status === 200) {
                    let data = response.data.data;
                    setConcesionarios(data);
                    setLoading(false);
                    setError(false);
                    return;
                }
                setLoading(false);
                setError(false);
            } catch (error) {
                setLoading(false);
                setError(false);
            }
        }
        fetchConcesionarios();
    }, [])
    return { concesionarios, error, loading }
}

export const useCategoriasSeccion = (seccion) => {
    const [categorias, setCategorias] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const AC = new AbortController();
        const fetchModelos = async () => {
            try {
                let response = await clienteAxios.get(`categorias/modulo/${seccion}`);

                setLoading(false);

                if (response.status === 200) {
                    const data = response.data.data;
                    setCategorias(data);
                    return;
                }

                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        if (seccion) fetchModelos();

        return () => AC.abort();
    }, [seccion])

    return { categorias, loading, error };
}

export const useSubcategoriaCategoria = (idCategoria) => {
    const [subcategorias, setSubcategorias] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const AC = new AbortController();
        const fetchSubCategorias = async () => {
            try {
                let response = await clienteAxios.get(`buscarCategoriaPorSubcategoria/${idCategoria}`);
                setLoading(false);

                if (response.status === 200) {
                    let data = response.data.data;
                    setSubcategorias(data);
                    return;
                }
                setError(true);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
        if (idCategoria) fetchSubCategorias();

        return () => AC.abort();

    }, [idCategoria])

    return { subcategorias, loading, error }
}

export const useModelosIdCategoria = (idCategoria) => {
    const [modelos, setModelos] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchModelos = async () => {

            let object = {
                idCategoria,
                Modulo: "MODELOS"
            }

            try {
                let response = await clienteAxios.post('modelo/filtro', object);
                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    let vehiculos = data[0].vehiculos && data[0].vehiculos;
                    setModelos(vehiculos);
                    return;
                }
            } catch (error) {
                setError(false);
                setLoading(false);
            }
        }
        if (idCategoria) fetchModelos();

    }, [idCategoria])

    return { modelos, loading, error }
}

export const useModelosServicio = () => {
    const [modelos, setModelos] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchModelos = async () => {
            let objeto = {
                Modulo: "MODELOS",
                idCategoria: 0
            }
            try {
                let response = await clienteAxios.post('modelo/filtro', objeto);
                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;

                    const vehiculos = []

                    data.map(d => d.vehiculos.map(ve => vehiculos.push(ve)))

                    setModelos(vehiculos);
                    return;
                }
                setError(true);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }
        fetchModelos();
    }, []);

    return { modelos, loading, error }
}

export const useModelosCotizar = (filtro) => {
    const [modelos, setModelos] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchModelos = async () => {
            try {
                let response = await clienteAxios.post('cotizacion/filtro/vehiculo', filtro);
                setLoading(false);
                if (response.status === 200) {
                    let data = response.data.data;
                    setModelos(data);
                    return;
                }

                setError(true);
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }

        if (filtro.idCategoria !== undefined) {

            fetchModelos();
        }

    }, [filtro])

    return { modelos, loading, error }
}

export const useModeloSlug = (slug) => {
    const [vehiculo, setVehiculo] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchVehiculo = async () => {
            try {
                let response = await clienteAxios.get(`Modelo/fichaVehiculo/${slug}`);
                setLoading(false);

                if (response.status === 200) {
                    let data = response.data.data;
                    setVehiculo(data);

                    return;
                }

                setError(true)
            } catch (error) {
                setError(true)
            }
        }

        if (slug) {
            fetchVehiculo();
        }
    }, [slug])
    return { vehiculo, loading, error }
}